import { render, staticRenderFns } from "./WarnIndirizzoDiSpedizione.vue?vue&type=template&id=6b37cfe7&"
import script from "./WarnIndirizzoDiSpedizione.vue?vue&type=script&lang=js&"
export * from "./WarnIndirizzoDiSpedizione.vue?vue&type=script&lang=js&"
import style0 from "./WarnIndirizzoDiSpedizione.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports